import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment';
import globals from './../../globals/communityGlobals';
import { checkFeatureAccess } from './../../utils/helpers';

export const eventHandlers = (state, setState) => {
  const dispatch = useDispatch();

  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });

  const onClose = () => {
    setState(newState => ({ ...newState, openSidePanel: false }));
  };

  const onFiltersChange = model =>
    setState({
      ...state,
      selectedTeams: model.selectedTeams,
      selectedClinician: model.selectedClinician,
      dateFrom: model.dateFrom,
      dateTo: model.dateTo,
      nhsNumber: model.nhsNumber,
      currentPage: 1,
    });

  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
    }));

  const featureAccessList = useSelector(s => s.global.auth.featureAccessList);

  const isAllocator =
    checkFeatureAccess(featureAccessList, globals.applicationFeatureAccesses.canAllocateWork) ||
    checkFeatureAccess(featureAccessList, globals.applicationFeatureAccesses.canTrigerSync);

  return {
    locale: globals.getAreas(['visitActuals', 'error', 'selectableListsValues', 'clinicianGroups', 'userActions']),
    dateFormats: globals.dateFormats.shortWithLongTime,
    moment,
    updateTableProps,
    updateTableSort,
    onClose,
    onFiltersChange,
    refreshTable,
    isAllocator,
    go: url => dispatch(push(url)),
  };
};
